import { render, staticRenderFns } from "./vbFooter.vue?vue&type=template&id=0e149d5a&"
import script from "./vbFooter.vue?vue&type=script&lang=js&"
export * from "./vbFooter.vue?vue&type=script&lang=js&"
import style0 from "./vbFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports